<template>
  <div class="layout-footer">
    <span class="font-medium ml-2">&copy; 2021 - ITP</span>
  </div>
</template>

<script lang="ts">
export default {
  name: "AppFooter",
  computed: {
    darkTheme() {
      // @ts-ignore
      return this.$appState.theme.startsWith("saga");
    },
  },
};
</script>

<style scoped></style>
